import { isConnect } from '../../../../utils/isConnect';
import areas from './InitialState.rw.prod';

const areasList = isConnect() ? [] : areas;

export default areasList;
